
import React, { useState } from 'react';
import { UplivionWheelPicker } from '@/components/ui/UplivionWheelPicker';

const WheelPickerTest = () => {
  const [selectedTime, setSelectedTime] = useState({ hour: '01', minute: '00', meridiem: 'AM' });

  const handleSelectionChange = (selections: { hour: string; minute: string; meridiem: string }) => {
    setSelectedTime(selections);
  };

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold text-center mb-8">Wheel Picker Test Page</h1>
        
        <div className="bg-white rounded-lg shadow-lg p-6 mb-8">
          <h2 className="text-xl font-semibold mb-4">Uplivion Wheel Picker</h2>
          <p className="text-gray-600 mb-4">Testing new wheel picker component with time selection</p>
          
          <div className="flex justify-center mb-4">
            <UplivionWheelPicker onSelectionChange={handleSelectionChange} />
          </div>
          
          <div className="mt-4 p-4 bg-gray-100 rounded">
            <h3 className="font-medium mb-2">Debug Output:</h3>
            <p>Selected Time: {selectedTime.hour}:{selectedTime.minute} {selectedTime.meridiem}</p>
            <div className="mt-2 text-sm text-gray-600">
              <p>Hour: {selectedTime.hour}</p>
              <p>Minute: {selectedTime.minute}</p>
              <p>Meridiem: {selectedTime.meridiem}</p>
            </div>
          </div>
        </div>
        
        <div className="bg-white rounded-lg shadow-lg p-6">
          <h2 className="text-xl font-semibold mb-4">Test Configurations</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="border border-gray-200 rounded-lg p-4">
              <h3 className="font-medium mb-2">Single Wheel</h3>
              <div className="border border-dashed border-gray-300 rounded p-4 text-center text-gray-500">
                Year Picker (Coming Next)
              </div>
            </div>
            
            <div className="border border-gray-200 rounded-lg p-4">
              <h3 className="font-medium mb-2">Multiple Wheels</h3>
              <div className="border border-dashed border-gray-300 rounded p-4 text-center text-gray-500">
                Year + Month + Day (Coming Next)
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WheelPickerTest;
